{
  "states": {
    "loading": "Chargement...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Dégagé",
    "Clouds": "Nuageux",
    "Rain": "Pluie",
    "Drizzle": "Bruine",
    "Thunderstorm": "Orage",
    "Snow": "Neige",
    "Mist": "Brume",
    "Smoke": "Fumée",
    "Haze": "Brume sèche",
    "Dust": "Poussière",
    "Fog": "Brouillard",
    "Sand": "Sable",
    "Ash": "Cendres",
    "Squall": "Bourrasque",
    "Tornado": "Tornade"
  },
  "modal": {
    "defaultTitle": "Météo",
    "subtitle": "Conditions actuelles",
    "showFahrenheit_aria": "Afficher en Fahrenheit",
    "showCelsius_aria": "Afficher en Celsius",
    "switchToCelsius_title": "Passer en °C",
    "switchToFahrenheit_title": "Passer en °F",
    "feelsLike": "Ressenti {{temp}}°{{unit}}",
    "humidityWind": "Humidité {{humidity}} % · Vent {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Maintenant",
    "hourlyOffset": "{{hours}} h",
    "hourlyStrip_aria": "Température horaire",
    "hourlyLocked": "Les prévisions horaires sont une fonctionnalité Pro.",
    "statsLocked": "Les détails météo sont une fonctionnalité Pro.",
    "stats": {
      "sunrise": "Lever du soleil",
      "sunset": "Coucher du soleil",
      "feels": "Ressenti",
      "humidity": "Humidité",
      "wind": "Vent",
      "rain": "Pluie"
    },
    "rainInches": "{{value}} po",
    "forecastTitle": "Prévisions sur 5 jours",
    "forecastLoading": "Chargement des prévisions…",
    "forecastUnavailable": "Prévisions indisponibles",
    "forecastLocked": "Les prévisions sur 5 jours sont une fonctionnalité Pro.",
    "forecastRow_aria": "Prévisions sur cinq jours",
    "proHeadline": "Les prévisions complètes font partie de Pro.",
    "proFeatures": "Heure par heure · Conditions détaillées · Aperçu sur 5 jours."
  }
}
